import React from 'react';
import * as Styles from 'pages/member/dns/DNS.style';
import { H6 } from 'components/reusable-css';
import Input from 'components/input';
import CustomButton from 'components/common/custom-button/custom-button';
import { Form, Formik } from 'formik';
import { addRecordsValidation, addRecordsValues } from '../util';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TxtForm = ({ handleAddRecord, loading }) => {
  const { t } = useTranslation();
  const isbigDesktop = useMediaQuery('(min-width:1350px)');
  const isDesktop = useMediaQuery('(max-width:1350px)');
  const isTablet = useMediaQuery('(max-width:1200px)');
  const isMobile = useMediaQuery('(max-width:1100px)');

  let areaWidth = isMobile ? '100%' : isbigDesktop ? '30rem' : isTablet ? '20rem' : isDesktop ? '25rem' : '100%';
  return (
    <Formik
      initialValues={addRecordsValues('TXT')}
      validationSchema={addRecordsValidation('txt')}
      onSubmit={(values, { resetForm }) => handleAddRecord(values, resetForm)}
    >
      {({ values, handleChange, handleBlur, errors, touched }) => (
        <Form>
          <Styles.SaveContainer>
            <Styles.SaveContainerColumn>
              <H6>{t('dns/instance.string31')}</H6>
              <Input
                disabled
                placeholderClass
                styling={{ marginTop: '-6px', maxWidth: '8rem' }}
                name={'type'}
                value={values['type']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['type']}
                touched={touched['type']}
              />
            </Styles.SaveContainerColumn>
            <Styles.SaveContainerColumn>
              <H6>{t('dns/instance.string32')}</H6>
              <Input
                placeholderClass
                styling={{ marginTop: '-6px', width: '100%' }}
                name={'name'}
                value={values['name']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['name']}
                touched={touched['name']}
              />
            </Styles.SaveContainerColumn>
            <Styles.SaveContainerColumn>
              <H6>{t('dns/instance.string41')}</H6>
              <Input
                styling={{ marginTop: '-6px', width: '100%', minWidth: areaWidth }}
                name={'value'}
                placeholderClass
                multiline
                value={values['value']}
                error={errors['value']}
                touched={touched['value']}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Styles.SaveContainerColumn>
            <Styles.SaveContainerbtnColumn style={{ justifyContent: 'flex-start', marginTop: '3.1em' }}>
              <CustomButton isLoading={loading} type="submit" buttonStyles={{ height: '52px', padding: '0 2rem' }} />
            </Styles.SaveContainerbtnColumn>
          </Styles.SaveContainer>
        </Form>
      )}
    </Formik>
  );
};
export default TxtForm;
